import { render, staticRenderFns } from "./HangTags.vue?vue&type=template&id=2f10d223"
import script from "./HangTags.vue?vue&type=script&lang=js"
export * from "./HangTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports